export const contactMergeQueryRootKey = ["crm-contact-merge"] as const;

export const contactMergeDefaultListParams = {
  page: 1,
  pageSize: 5,
};

export const contactMergeStatusLabels: Record<string, string> = {
  draft: "草稿",
  pending_review: "待审核",
  approved: "已审核",
  executing: "执行中",
  succeeded: "已完成",
  rejected: "已驳回",
  cancelled: "已取消",
  failed: "执行失败",
  blocked: "已阻断",
};
